import { HARDWARE_FINISHES } from "./catalog";

export const hardwareFinishColor = (finish) => {
  const name = String(finish || "").trim().toLowerCase();
  const swatch = HARDWARE_FINISHES.find((entry) => entry.name.toLowerCase() === name);
  if (swatch) return swatch.hex;
  if (name.includes("black")) return "#0a0a0a";
  if (/brass|gold/.test(name)) return "#c39a5a";
  return "#d1d1d1";
};